import React, { useEffect, useRef, useState } from 'react';
import { translate } from "../../Services/translation";

const ExceedsBudgetCard = ({ splitPaymentApproved, setSplitPaymentApproved }) => {
    const [message, setMessage] = useState('');

    useEffect(() => {
        setMessage("");
    }, [splitPaymentApproved]);

    function handleOnClick(){
        if(!ref.current.checked){
            setMessage(translate('checkout.forms.exceededbudget.checkbox.error'));

            return;
        }

        setSplitPaymentApproved(!splitPaymentApproved);
    }

    const ref = useRef();

    return (
        <div className="card">
            <div className="card__body card__body--large">
                <div className="checkout__form-container">

                    <div>
                        <p className="checkout__label">{translate('checkout.form.exceededbudget.label')}</p>

                        <p>{translate('checkout.forms.exceededbudget.text')}</p>

                        <label className="checkout__checkbox-label" htmlFor="exceedsbudget-checkbox">
                            <input className="checkout__checkbox" id="exceedsbudget-checkbox" ref={ref} type="checkbox" disabled={splitPaymentApproved}/>
                            <span>{translate('checkout.forms.exceededbudget.checkbox.text')}</span>
                        </label>

                        {message && <p className="checkout__input-validation-error">{message}</p>}

                        <button
                            onClick={() => handleOnClick()}
                            className="checkout__form-group-button"
                            type="button">{splitPaymentApproved ? translate('checkout.forms.edit') : translate('checkout.forms.next')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExceedsBudgetCard;
